const errorCodes = {
  unauthenticated: 401,
  forbidden: 403,
  notFound: 404,
};

export default errorCodes;
